/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import 'location-origin'; // IE 10 window.location.origin fix
import Swagger from 'swagger-client';
import { API_URI } from '../config/app_config';

export const buildAccountServiceClient = () => {
  const swagger = new Swagger({
    url: API_URI,
    usePromise: true,
  });

  // Reconfigure swagger client to override service path if we're using a reverse proxy:
  // /accountservice/swagger.json -> /accountservice
  // Originally tried setting basePath to null, undefined, and '', but that didn't work
  let basePath;
  if (API_URI.startsWith('/')) {
    basePath = API_URI.substring(0, API_URI.lastIndexOf('/'));
    swagger.then(client => {
      client.setBasePath(basePath);
      if (typeof window !== 'undefined') {
        // use current protocol, so either http or https
        client.setSchemes([window.location.protocol.slice(0, -1)]);
      }
    });
  }
  return swagger;
};

// cache swagger client, so we only load swagger.json once:
let accountServiceSwagger = null;
export const accountServiceClient = () => {
  if (accountServiceSwagger === null) {
    accountServiceSwagger = buildAccountServiceClient();
  }
  return accountServiceSwagger;
};
